export default {"src":"/_next/static/media/chevron-right.e5fad6f5.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};